<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <modal-form modal-id="add-link-order" animation="fadeInRight">
      <div slot="title">Add Link Order</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-3">Name</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="addOrder['name']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Client</div>
            <div class="col-lg-9">
              <v-select :options="this.f.clients" v-model="addOrder['client']" label="name" index="id"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Group</div>
            <div class="col-lg-9">
              <v-select
                :options="this.f.groups"
                label="name"
                index="id"
                v-model="addOrder['group']"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Categories</div>
            <div class="col-lg-9">
              <v-select
                :options="this.f.categories"
                v-model="addOrder['category']"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Build Order</div>
            <div class="col-lg-9">
              <v-select
                :options="[{id: null, name: '>>>'}].concat(this.f.orders)"
                label="name"
                index="id"
                v-model="addOrder['buildOrder']"
                @input="updateOrderCount"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Language</div>
            <div class="col-lg-9">
              <v-select :options="langs" v-model="addOrder['language']" label="label" index="index"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Backup Language</div>
            <div class="col-lg-9">
              <v-select :options="langs" v-model="addOrder['backupLang']" label="label" index="index"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Number</div>
            <div class="col-lg-9">
              <input type="number" min="1" class="form-control" v-model="addOrder['number']">
            </div>
          </div>
          <div class="row m-b-md">
            <div class="col-lg-12">
              <div class="m-t-sm">Targets (url,[anchor],[domain])</div>
              <textarea
                v-model="csvTargets" rows="10" class="pull-right form-control m-t-sm" placeholder="Targets csv (link,anchor,number)"></textarea>

            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Source Clients</div>
            <div class="col-lg-9">
              <v-select :options="this.f.clients" multiple v-model="addOrder['source']['clients']" label="name" index="id"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Source Groups</div>
            <div class="col-lg-9">
              <v-select
                multiple
                :options="this.f.groups"
                label="name"
                index="id"
                v-model="addOrder['source']['groups']"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Deadline</div>
            <div class="col-lg-9">
              <input type="date" class="form-control" v-model="addOrder['deadline']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Description</div>
            <div class="col-lg-9">
              <textarea class="form-control" rows="10" v-model="addOrder['description']"></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <button class="btn btn-sm btn-primary" @click="saveOrder">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Link Orders</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-link-order">Add order</button>
      </div>
      <div class="ibox-content col-lg-12">
        <filters></filters>
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from './Links/Orders/Filters'
import List from './Links/Orders/List'
import axios from 'axios'
import { LINK_ORDERS_SET } from '../../../store/mutation-types'
import Modal from '../../Helpers/Modal/Form'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      addOrder: {
        source: {}
      },
      targets: [{}],
      csvTargets: ''
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      langs: 'getLanguages'
    })
  },
  mounted () {
    document.title = 'Link Placement Orders :: PBN360 by Aphex Media'
    this.getOrders()
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }

    if (!this.langs.length) {
      this.$store.dispatch('loadLanguages')
    }
  },
  components: {
    filters: Filters,
    list: List,
    modalForm: Modal
  },
  methods: {
    saveOrder () {
      if (this.csvTargets.length < 3) {
        this.$toastr.error('Please add targets to the order', 'Targets missing')
        return
      }

      this.addOrder.targets = []
      this.csvTargets.split('\n').forEach(line => {
        let l
        if (line.split(',').length > 1) {
          // We have a csv
          l = line.split(',')
        } else {
          l = line.split('\t')
        }
        if (l[0] && l[0].length > 4) {
          this.addOrder.targets.push({
            url: l[0],
            anchor: l[1],
            number: l[2] || 1,
            targetDomain: ''
          })
        }
      })

      if (!this.addOrder.name || !this.addOrder.client || !this.addOrder.number || !this.addOrder.targets) {
        this.$toastr.error('Some data seems to be missing', 'Please try a bit harder')
        return
      }

      axios.post('/pbn/links/order', this.addOrder)
        .then(r => {
          this.getOrders()
          this.addOrder = {}
          $('#add-link-order').modal('hide')
          this.$toastr.success('Order added successfully', 'Brilliant stuff lad')
        })
        .catch(e => {
          this.$toastr.error(e, 'Not so great is it...')
        })
    },
    getOrders () {
      axios.get('/pbn/links/orders')
        .then(r => {
          this.$store.commit(LINK_ORDERS_SET, r.data.data)
        })
        .catch(e => {
          this.$toastr.error(e)
        })
    },
    updateOrderCount (id) {
      this.f.orders.forEach(o => {
        if (o.id === id) {
          this.addOrder.number = o.size
          return true
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/LinkOrders.vue